export const useSurveyChannel = () => {
  const allowedChannels = [
    'ph_jms',
    'id_infield_app',
    'th_infield_app',
    'ph_infield_app',
    'my_infield_app',
    'sg_outfield_app',
    'sg_infield_app',
    'kh_outfield_app',
    'kh_infield_app',
    'mex_infield_app',
    'br_infield_app',
    'eg_outfield_app',
    'eg_infield_app',
    'co_outfield_app',
    'co_infield_app',
    'cn_yydriver_app',
    'cn_infield_app',
    'ph_outfield_app',
    'cn_tumishu_app',
    'my_outfieid_app',
    'ph_driver_app'
  ]

  const isAllowedChannel = (channel?: string | null) => {
    if (!channel) return false
    return allowedChannels.includes(channel)
  }

  return {
    isAllowedChannel
  }
}
